/**
 * Account page module
 *
 * @module views/pages/account-page
 */
define('views/pages/requests/table',['require','jquery','underscore','views/base/collection','./table-row','text!templates/pages/requests/table.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        CollectionView = require('views/base/collection'),
        TableRowView = require('./table-row'),
        template = require('text!templates/pages/requests/table.ejs');

    var TableView = CollectionView.extend({
        autoRender: true,
        tagName: 'table',
        className: 'table table-bordered table-hover',
        itemView: TableRowView,
        animationDuration: 0,
        template: template,
        listSelector: 'tbody',
        loadingSelector: '.loading',
        fallbackSelector: '.empty',
        listen: {
            'resize model': 'onResize',
            'addedToDOM': 'onResize'
        },
        render: function() {
            CollectionView.prototype.render.apply(this, arguments);

            this.$('tbody').off('scroll').on('scroll', _.bind(function() { this.$('.icon-comment').popover('destroy'); }, this));
        },
        onResize: function() {
            var h = $('body').height();
            var $b = this.$('tbody');
            $b.css('height', h - $b.offset().top - 12);
        }
    });

    return TableView;
});

